import { createSelector } from 'reselect';
import { RootState } from '../reducers';

const selector: (state: RootState) => any = (state: RootState) => state.user;

export const userSelector = createSelector(selector, (user) => user);
